import { notification } from "antd";
import { useEffect } from "react";
import { useAuthStore } from "store/auth.store";
import { config } from "utils/config";
import type { EventSourceMessage } from "utils/eventsource";
import { fetchEventSource } from "utils/eventsource";

const closed: string[] = [];

// fetchEventSource retries a failed stream every second by default, from every
// open tab.
const RETRY_AFTER_FAILURE_MS = 30_000;

export function Events() {
	const token = useAuthStore((state) => state.token);
	const [api, contextHolder] = notification.useNotification();

	useEffect(() => {
		const ctrl = new AbortController();
		const url = config.api.baseURL + "sse";
		if (!token) return;
		fetchEventSource(url, {
			signal: ctrl.signal,
			// No body: this is a GET, and fetch throws on a GET with a body before
			// any request is sent. The server scopes events to the signed-in user.
			headers: { Authorization: `Bearer ${token}` },
			onmessage: onMessage,
			onclose: () => {},
			onerror: () => RETRY_AFTER_FAILURE_MS,
		});

		return () => {
			ctrl.abort();
		};
	}, [token]);

	const onMessage = (event: EventSourceMessage) => {
		try {
			const data = JSON.parse(event.data.replaceAll("\\", "")) as IMessage;
			console.info("onMessage sse", data);

			if (!data?.id || !data?.payload?.message) return;
			if (closed.includes(data?.id)) return;

			api.info({ message: "Info", description: data?.payload?.message });
		} catch (error) {
			console.log("error: " + error);
		}
	};

	return contextHolder;
}

interface IMessage {
	id: string;
	type: EventType;
	payload: {
		message: string;
	};
}

enum EventType {
	Connection,
}
